module.exports = __webpack_public_path__ + "img/adminD 6.5dd3b84b.png";